import { clearEmailCampaignError } from '@spike/email-marketing-action';
import Button from 'components/UI/V3/Button/Button';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import { formatCampaignNameError } from '../formatCampaignNameError';
import { EmailCampaignStepProps } from '../types';

import styles from './CampaignNameStep.module.scss';

export const CampaignNameStep: React.FC<EmailCampaignStepProps> = ({
    values,
    hideContinueButton = false,
    continueDisabled,
    onChange,
    onContinue
}) => {
    const dispatch = useDispatch();
    const validationErrors = useSelector((state: RootState) => state.emailCampaigns.validationErrors);

    const nameError =
        validationErrors?.name && validationErrors.name.length > 0
            ? formatCampaignNameError(validationErrors.name)
            : null;

    const handleChangeName = (value: string) => {
        // Clear any standing error so the input stops flagging while the user
        // is typing a new candidate. The next Continue will re-validate.
        if (validationErrors) {
            dispatch(clearEmailCampaignError());
        }
        onChange({ campaignName: value });
    };

    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <h2 className={styles.title}>New Email Campaign</h2>

                <Input
                    label="Campaign Name"
                    placeholder="Campaign Name"
                    value={values.campaignName}
                    onChange={event => handleChangeName(event.target.value)}
                    required
                    error={nameError}
                    maxLength={100}
                    className={styles.input}
                />

                {!hideContinueButton && (
                    <Button
                        size="large"
                        label="Continue"
                        disabled={continueDisabled}
                        noColorOnDisabled
                        className={styles.continueButton}
                        onClick={onContinue}
                    />
                )}
            </div>
        </div>
    );
};
